module.exports = __webpack_public_path__ + "static/media/piggy.b46f1aeb.png";